import { DEFAULT_PERIOD, resolvePeriod } from "../components/periods";
import { getStoredBillingCompany } from "../billingCompany";

const normalizePage = page => {
    const parsedPage = parseInt(page, 10);
    return Number.isNaN(parsedPage) || parsedPage < 1 ? 1 : parsedPage;
};

const parsePeriod = params => {
    const preset = params.get('period') || DEFAULT_PERIOD;

    if (preset === 'all') return { preset, start: '', end: '' };

    if (params.get('start') && params.get('end')) {
        return { preset, start: params.get('start'), end: params.get('end') };
    }

    return resolvePeriod(preset);
};

export const parseStatementFilters = search => {
    const params = new URLSearchParams(search);

    return {
        page: normalizePage(params.get('page')),
        period: parsePeriod(params),
        search: params.get('search') || '',
        accountIds: params.getAll('account'),
        types: params.getAll('type'),
        situations: params.getAll('situation'),
        reconciled: params.get('reconciled') || '',
        categoryId: params.get('category') || '',
        costCenterId: params.get('cost_center') || '',
        companyId: params.get('company') || '',
        companyLabel: params.get('company_label') || '',
        origins: params.getAll('origin'),
        amountMin: params.get('amount_min') || '',
        amountMax: params.get('amount_max') || '',
        card: params.get('card') || '',
        // Ausente na URL é "a que eu escolhi por último", como nas listas de
        // títulos.
        billingCompanyId: params.has('billing_company')
            ? (params.get('billing_company') || '')
            : getStoredBillingCompany(),
        sort: params.get('sort') || 'movement_date',
        orientation: params.get('orientation') || 'asc',
    };
};

export const buildStatementSearch = filters => {
    const params = new URLSearchParams();

    if (filters.page > 1) params.set('page', filters.page);
    if (filters.period.preset !== DEFAULT_PERIOD || filters.period.start !== resolvePeriod(DEFAULT_PERIOD).start) {
        params.set('period', filters.period.preset);
        if (filters.period.preset !== 'all') {
            params.set('start', filters.period.start);
            params.set('end', filters.period.end);
        }
    }
    if (filters.search) params.set('search', filters.search);
    filters.accountIds.forEach(id => params.append('account', id));
    filters.types.forEach(type => params.append('type', type));
    filters.situations.forEach(situation => params.append('situation', situation));
    if (filters.reconciled) params.set('reconciled', filters.reconciled);
    if (filters.categoryId) params.set('category', filters.categoryId);
    if (filters.costCenterId) params.set('cost_center', filters.costCenterId);
    if (filters.companyId) {
        params.set('company', filters.companyId);
        if (filters.companyLabel) params.set('company_label', filters.companyLabel);
    }
    filters.origins.forEach(origin => params.append('origin', origin));
    if (filters.amountMin) params.set('amount_min', filters.amountMin);
    if (filters.amountMax) params.set('amount_max', filters.amountMax);
    if (filters.card) params.set('card', filters.card);
    if (filters.billingCompanyId) params.set('billing_company', filters.billingCompanyId);
    if (filters.sort !== 'movement_date') params.set('sort', filters.sort);
    if (filters.orientation !== 'asc') params.set('orientation', filters.orientation);

    return params.toString();
};

// Mesmos parâmetros para a lista, os cards, a planilha e o PDF: é o que
// garante que os quatro mostram o mesmo recorte.
export const buildStatementApiQuery = (filters, { withPage = true } = {}) => {
    const params = new URLSearchParams();

    if (filters.period.start) params.set('start', filters.period.start);
    if (filters.period.end) params.set('end', filters.period.end);
    if (filters.search) params.set('search', filters.search);
    filters.accountIds.forEach(id => params.append('bank_account_id[]', id));
    filters.types.forEach(type => params.append('type[]', type));
    filters.situations.forEach(situation => params.append('situation[]', situation));
    if (filters.reconciled) params.set('reconciled', filters.reconciled);
    if (filters.categoryId) params.set('finance_category_id', filters.categoryId);
    if (filters.costCenterId) params.set('finance_cost_center_id', filters.costCenterId);
    if (filters.companyId) params.set('company_id', filters.companyId);
    filters.origins.forEach(origin => params.append('origin[]', origin));
    if (filters.amountMin) params.set('amount_min', filters.amountMin);
    if (filters.amountMax) params.set('amount_max', filters.amountMax);
    if (filters.card) params.set('card', filters.card);
    if (filters.billingCompanyId) params.set('billing_company_id', filters.billingCompanyId);
    params.set('ordenation_item', filters.sort);
    params.set('orientation', filters.orientation);
    if (withPage) params.set('page', filters.page);

    return params.toString();
};
